<ngx-gov-co-shd-app-header-auth>
  <div shd-container-router-component>
    <div class="container-shd-component-menu-panel-right">
      <div class="row-shd-component-menu-panel-right">
        <div class="col-main-shd-component-menu-panel-right">
          <nav aria-label="breadcrumb-shd-component-menu-panel-right">
            <ol class="breadcrumb-shd-component-menu-panel-right">
              <li class="breadcrumb-item-shd-component-menu-panel-right">
                <a href="javascript:void(0)">Mis impuestos</a>
              </li>
              <li class="breadcrumb-item-shd-component-menu-panel-right">
                <a href="javascript:void(0)">Retención ICA</a>
              </li>
              <li class="breadcrumb-item-shd-component-menu-panel-right">
                <a href="javascript:void(0)" class="active">Pagar</a>
              </li>
            </ol>
          </nav>
          <div class="banner-step-info-container">
            <div class="banner-step-info-content">
              <div class="step-circle">3</div>
              <span class="banner-step-info-texto">Pagar</span>
            </div>
            <div class="banner-step-info-imagen-container">
              <img [src]="urlsPaso.tres" alt="Pagar" class="banner-step-info-imagen">
            </div>
          </div>
          
          <div *ngIf="originalData.length > 0 && showViewHTMLComponent">
            <div class="search-results-bar">
              <input type="text" class="search-input-results" (input)="applyFilter()" placeholder="Buscar" name="filtro"
                [(ngModel)]="filterTerm">
              <button class="search-button" (click)="applyFilter()">
                <span class="material-symbols-outlined">
                  search
                </span>
              </button>
            </div>
            <div id="data-table-component" class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>
                      <div (click)="sortTable('vigencia')">
                        <span>Vigencia</span>
                        <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'vigencia' && this.sortDirection == 'asc'">arrow_upward_alt</span>
                        <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'vigencia' && this.sortDirection == 'desc'">arrow_downward_alt</span>
                        <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy !== 'vigencia'">unfold_more</span>
                      </div>
                    </th>
                    <th>
                      <div (click)="sortTable('nombrePeriodo')">
                        <span>Período</span>
                        <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'nombrePeriodo' && this.sortDirection == 'asc'">arrow_upward_alt</span>
                        <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'nombrePeriodo' && this.sortDirection == 'desc'">arrow_downward_alt</span>
                        <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy !== 'nombrePeriodo'">unfold_more</span>
                      </div>
                    </th>
                    <th>
                      <div (click)="sortTable('nroReferencia')">
                        <span>No. de referencia</span>
                        <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'nroReferencia' && this.sortDirection == 'asc'">arrow_upward_alt</span>
                        <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'nroReferencia' && this.sortDirection == 'desc'">arrow_downward_alt</span>
                        <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy !== 'nroReferencia'">unfold_more</span>
                      </div>
                    </th>
                    <th>
                      <div (click)="sortTable('fechaCreacion')">
                        <span>Fecha de creación	</span>
                        <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'fechaCreacion' && this.sortDirection == 'asc'">arrow_upward_alt</span>
                        <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'fechaCreacion' && this.sortDirection == 'desc'">arrow_downward_alt</span>
                        <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy !== 'fechaCreacion'">unfold_more</span>
                      </div>
                    </th>
                    <th>
                      <div (click)="sortTable('fechaPago')">
                        <span>Fecha máxima para realizar el pago</span>
                        <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'fechaPago' && this.sortDirection == 'asc'">arrow_upward_alt</span>
                        <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'fechaPago' && this.sortDirection == 'desc'">arrow_downward_alt</span>
                        <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy !== 'fechaPago'">unfold_more</span>
                      </div>
                    </th>
                    <th>
                      <div (click)="sortTable('valorPagar')">
                        <span>Valor</span>
                        <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'valorPagar' && this.sortDirection == 'asc'">arrow_upward_alt</span>
                        <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy == 'valorPagar' && this.sortDirection == 'desc'">arrow_downward_alt</span>
                        <span class="material-symbols-outlined material-symbols-filled" *ngIf="this.sortBy !== 'valorPagar'">unfold_more</span>
                      </div>
                    </th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of paginatedData">
                    <td>{{item.vigencia}}</td>
                    <td>{{item.nombrePeriodo}}</td>
                    <td>{{item.nroReferencia}}</td>
                    <td>{{item.fechaCreacion }}</td>
                    <td>{{item.fechaPago }}</td>
                    <td>{{item.valorPagar | currency:'COP':'$':'1.0-0'}}</td>
                    <td>
                      <div class="cell-table-actions">
                        <a href="javascript:void(0)" class="a-action-primary" (click)="irAPagar(item)">Pagar</a>
                        <div class="dropdown">
                          <span (click)="toggleMenu(item)" class="material-symbols-outlined material-symbols-filled" title="Ver más acciones" style="padding: 0px 20px;cursor: pointer;" [class.active]="item.$$isMenuOpen">
                            more_vert
                          </span>
                          <ul class="dropdown-content" [class.show]="item.$$isMenuOpen">
                            <li><a href="javascript:void(0)" (click)="printForm(item)"><span class="material-symbols-outlined material-symbols-filled">archive</span>Descargar</a></li>
                          </ul>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="paginatedData.length == 0 && originalData.length > 0" >
                    <td colspan="7" style="text-align: center;">
                      No se encontraron resultados asociados a tu búsqueda.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="pagination" *ngIf="pageNumbers.length != 0 && this.originalData.length > this.rowsPerPage">
              <span class="pagination-text control_boton_paginacion_1" (click)="prevPage()"
                [ngClass]="{ 'enabled-control-button' : currentPage !== 1 }">Anterior</span>
              <span class="pagination-text material-symbols-outlined material-symbols-filled control_boton_paginacion_2" (click)="prevPage()"
                [ngClass]="{ 'enabled-control-button' : currentPage !== 1 }">arrow_back_ios</span>
              <ng-container *ngFor="let page of pageNumbers">
                <button *ngIf="page !== '...'; else ellipsis" class="page-button" [class.active]="page === currentPage"
                  (click)="goToPage(page)"> {{page}}</button>
                <span>
                </span>
                <ng-template #ellipsis>
                  <span class="ellipsis enabled-control-button w700">...</span>
                </ng-template>
              </ng-container>
              <span class="pagination-text control_boton_paginacion_1" (click)="nextPage()"
                [ngClass]="{ 'enabled-control-button' : currentPage !== totalPages && totalPages !== 0 }">Siguiente</span>
              <span class="pagination-text material-symbols-outlined material-symbols-filled control_boton_paginacion_2" (click)="nextPage()"
                [ngClass]="{ 'enabled-control-button' : currentPage !== totalPages && totalPages !== 0 }">arrow_forward_ios</span>
            </div>
          </div>
          <div class="container-body-tab-item-result" *ngIf="originalData.length == 0 && showViewHTMLComponent">
            <div class="container-body-tab-item-result-view">
              <span class="material-symbols-outlined material-symbols-filled header-icon alert-info">event_available</span>
              <p class="header-icon-title alert-info" >Sin recibos pendientes de pago.</p>
              <p class="body-seccion">No encontramos recibos pendientes de pago en este momento.<br> Cuando se generen nuevos recibos pendientes de pago, aparecerán aquí para que los gestiones fácilmente.</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</ngx-gov-co-shd-app-header-auth>